/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown>, date: NonNullable<unknown> }} Sub_Contract_Plan_DetailInputs */



/**
* | output |
* | --- |
* | "Team plan with {seats} seats, until {date}." |
*
* @param {Sub_Contract_Plan_DetailInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const sub_contract_plan_detail = /** @type {((inputs: Sub_Contract_Plan_DetailInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sub_Contract_Plan_DetailInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Team-Tarif mit ${i?.seats} Plätzen, bis ${i?.date}.`)
	return /** @type {LocalizedString} */ (`Team plan with ${i?.seats} seats, until ${i?.date}.`)
});